import { isDefined } from "@clipboard-health/util-ts";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

export function formatTotalPayWithShiftBoost(
  originalAmount: number | undefined,
  shiftBoostAmount: number | undefined
) {
  return isDefined(originalAmount) && isDefined(shiftBoostAmount)
    ? formatDollarsAsUsd(originalAmount + shiftBoostAmount)
    : undefined;
}
